import { menuBgEl, menuEl, menuOpenBtnEl } from "./elements";
import { logEvent } from "./analytics";
import { stack } from "./nav";
import { updateStyles } from "./nav/styles";

export function openMenu(e) {
  e.preventDefault();
  menuEl.style.display = "initial";
  menuBgEl.style.display = "initial";
  menuOpenBtnEl.style.display = "none";
  logEvent("open_menu");
  stack.push("menu");
  updateStyles();
}

export function closeMenu(e) {
    e && e.preventDefault();
    menuOpenBtnEl.style.display = "initial";
    menuEl.style.display = "none";
    menuBgEl.style.display = "none";
    e && logEvent("close_menu");
    e && stack.pop();
    updateStyles();
}
